import React, { useEffect, useRef } from "react";
// import { createPortal } from "react-dom";

const VARIANT_MAP = {
  danger: {
    iconRing:   "bg-danger_bg border-danger_border text-danger",
    confirmBtn: "bg-danger hover:bg-danger/90 text-white",
  },
  warning: {
    iconRing:   "bg-warning_bg border-warning_border text-warning",
    confirmBtn: "bg-warning hover:bg-warning/90 text-white",
  },
  primary: {
    iconRing:   "bg-primary_tint border-border text-primary",
    confirmBtn: "bg-primary hover:bg-primary_hover text-white",
  },
  info: {
    iconRing:   "bg-info_bg border-info_border text-info",
    confirmBtn: "bg-info hover:bg-info/90 text-white",
  },
};

const ConfirmDialogue = ({ confirmData, handleConfirmClose }) => {
  const {
    title,
    message,
    confirmText = "Confirm",
    cancelText  = "Cancel",
    icon,
    variant     = "danger",
  } = confirmData;

  const cancelRef = useRef(null);
  const v = VARIANT_MAP[variant] ?? VARIANT_MAP.danger;

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") handleConfirmClose(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [handleConfirmClose]);

  useEffect(() => {
    cancelRef.current?.focus();
  }, []);

  // Portalled to <body> so an ancestor's layout (e.g. a `space-y-*` container
  // adding margin-top to a fixed overlay, shifting the backdrop down) or
  // stacking context can never affect it — the backdrop always fills the viewport.
  // return createPortal(
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-title"
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/45 backdrop-blur-[2px] animate-confirm-fade"
        onClick={() => handleConfirmClose(false)}
      />

      {/* Card */}
      <div className="relative w-full max-w-[400px] animate-confirm-in">
        <div className="bg-surface border border-border rounded-xl overflow-hidden
          shadow-[0_20px_50px_rgba(0,0,0,0.18)]">

          {/* Body */}
          <div className="p-6 pb-5">
            {icon && (
              <div className={`flex h-12 w-12 items-center justify-center
                rounded-[14px] border mb-[18px] ${v.iconRing}`}>
                {icon}
              </div>
            )}

            <h3
              id="confirm-title"
              className="text-[17px] font-medium text-text_primary leading-snug mb-2"
            >
              {title}
            </h3>
            <p className="text-[13.5px] text-text_secondary leading-relaxed">
              {message}
            </p>
          </div>

          {/* Footer actions */}
          <div className="flex gap-2.5 px-6 py-4 bg-surface_alt
            border-t border-border">
            <button
              ref={cancelRef}
              onClick={() => handleConfirmClose(false)}
              className="flex-1 px-4 py-2.5 rounded-[10px] text-[13px] font-medium
                text-text_secondary bg-surface border border-border
                hover:border-border_strong hover:text-text_primary
                transition-all duration-150 focus:outline-none
                focus-visible:ring-2 focus-visible:ring-border_strong"
            >
              {cancelText}
            </button>
            <button
              onClick={() => handleConfirmClose(true)}
              className={`flex-1 px-4 py-2.5 rounded-[10px] text-[13px] font-medium
                transition-all duration-150 focus:outline-none
                focus-visible:ring-2 focus-visible:ring-offset-2
                focus-visible:ring-offset-surface ${v.confirmBtn}`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes confirm-in {
          from { opacity: 0; transform: scale(0.94) translateY(8px); }
          to   { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes confirm-fade {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        .animate-confirm-in {
          animation: confirm-in 0.18s cubic-bezier(0.34, 1.36, 0.64, 1) forwards;
        }
        .animate-confirm-fade {
          animation: confirm-fade 0.15s ease-out forwards;
        }
      `}</style>
    </div>
    // document.body
  );
};

export default ConfirmDialogue;